define.alias("shared/components/shared/modal/banner", "calendar/components/shared/modal/banner");